import React from 'react';

export default function MapboxTechnicianMap() {
  return (
    <div className="sa-map-unavailable">
      Mapbox provider is configured but not installed yet.
    </div>
  );
}
